import type {BoardLane} from './board-lanes'

export const BOARD_LANE_LABELS: Record<BoardLane, string> = {
    needs_action: 'Needs action',
    notify_drivers: 'Notify drivers',
    dispatched: 'Dispatched',
}

export const BOARD_NEEDS_ACTION_VIEW_LABEL = 'Needs action in view'
